(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jxs-product-sticky-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-sticky-nav')) {
    class ProductStickyNav extends HTMLElement {
      connectedCallback() {
        this.links = Array.from(this.querySelectorAll('[data-product-nav-link]'));
        this.hideSiteHeader = this.dataset.hideSiteHeader === 'true';
        this.sectionWrapper = this.closest('.section-product-sticky-nav') || this.closest('.shopify-section') || this.parentElement;
        this.siteHeaderSection = document.querySelector('.section-header');
        this.siteHeaderElement = this.siteHeaderSection?.querySelector('header.header');
        this.stickyHeader = document.querySelector('sticky-header');
        this.announcementSection = this.findAnnouncementSection();
        this.ticking = false;
        this.siteChromeVisible = true;
        this.onScroll = this.handleScroll.bind(this);
        this.onResize = this.handleResize.bind(this);
        this.onClick = this.handleClick.bind(this);
        this.onHeaderMenuStateChange = this.syncHeaderMenuState.bind(this);

        this.links.forEach((link) => link.addEventListener('click', this.onClick));
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.observeHeaderMenuState();

        this.updatePositions();
        this.handleScroll();
        this.updateActiveLink();
        this.syncHeaderMenuState();
      }

      disconnectedCallback() {
        this.links?.forEach((link) => link.removeEventListener('click', this.onClick));
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.headerMenuObserver?.disconnect();
        this.sectionWrapper?.removeAttribute('menu-drawer-open');
        this.clearSiteHeaderState();
      }

      observeHeaderMenuState() {
        if (!this.siteHeaderSection || typeof MutationObserver === 'undefined') {
          return;
        }

        this.headerMenuObserver = new MutationObserver(this.onHeaderMenuStateChange);
        this.headerMenuObserver.observe(this.siteHeaderSection, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      syncHeaderMenuState() {
        this.sectionWrapper?.toggleAttribute(
          'menu-drawer-open',
          Boolean(this.siteHeaderSection?.classList.contains('menu-open'))
        );
      }

      handleResize() {
        this.updatePositions();
        this.handleScroll();
      }

      handleClick(event) {
        const link = event.currentTarget;
        const targetType = link.dataset.targetType;

        if (targetType === 'url') {
          return;
        }

        event.preventDefault();

        if (targetType === 'overview') {
          const top = this.getSectionDocumentTop() - this.getCurrentStickyTop();
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          return;
        }

        if (targetType === 'top') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }

        const target = this.resolveTarget(link.dataset.targetId || link.getAttribute('href')?.replace('#', ''));
        if (!target) {
          return;
        }

        const offset = this.getBoundingClientRect().height + this.getCurrentStickyTop();
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }

      resolveTarget(rawTargetId) {
        const targetId = (rawTargetId || '').trim().replace(/^#/, '');
        if (!targetId) {
          return null;
        }

        const escapedTarget = window.CSS && CSS.escape ? CSS.escape(targetId) : targetId.replace(/"/g, '\\"');
        const idTarget = document.getElementById(targetId);
        if (idTarget) {
          return idTarget;
        }

        const anchorMarker = document.querySelector(`[anchor-id="${escapedTarget}"]`);
        if (anchorMarker) {
          if (anchorMarker.classList.contains('sticky-anchor')) {
            return anchorMarker.closest('.shopify-section')?.nextElementSibling || anchorMarker;
          }
          return anchorMarker.closest('.shopify-section') || anchorMarker;
        }

        return document.querySelector(
          `[section-anchor-id="${escapedTarget}"], [data-product-nav-anchor="${escapedTarget}"], #shopify-section-${escapedTarget}, [id$="__${escapedTarget}"]`
        );
      }

      handleScroll() {
        if (this.ticking) {
          return;
        }

        this.ticking = true;
        requestAnimationFrame(() => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

          if (this.hideSiteHeader) {
            if (scrollTop <= this.getSiteChromeRevealThreshold()) {
              this.setSiteChromeVisible(true, false);
            } else {
              this.setSiteChromeVisible(false);
            }
          } else {
            this.setSiteChromeVisible(true, false);
          }

          this.toggleAttribute('is-pinned', this.getBoundingClientRect().top <= this.getCurrentStickyTop() + 1 && scrollTop > 8);
          this.updateActiveLink();
          this.ticking = false;
        });
      }

      getSiteChromeRevealThreshold() {
        return 8;
      }

      clearSiteHeaderState() {
        this.sectionWrapper?.style.removeProperty('top');
        this.announcementSection?.style.removeProperty('position');
        this.announcementSection?.style.removeProperty('top');
        this.announcementSection?.style.removeProperty('right');
        this.announcementSection?.style.removeProperty('left');
        this.announcementSection?.style.removeProperty('z-index');
        this.announcementSection?.style.removeProperty('width');
        this.announcementSection?.style.removeProperty('transform');
        this.announcementSection?.style.removeProperty('transition');
        this.announcementSection?.style.removeProperty('pointer-events');

        if (this.siteHeaderElement) {
          this.siteHeaderElement.style.removeProperty('top');
          this.siteHeaderElement.style.removeProperty('transform');
          this.siteHeaderElement.style.removeProperty('transition');
          this.siteHeaderElement.style.removeProperty('pointer-events');
        }

        if (this.siteHeaderSection) {
          this.siteHeaderSection.classList.remove('shopify-section-header-sticky', 'animate', 'shopify-section-header-hidden');
        }
      }

      findAnnouncementSection() {
        const section = document.querySelector('[id*="announcement_bar"]');
        if (section) {
          return section;
        }

        const announcement = document.querySelector('.announcement-bar-wrap');
        return announcement?.closest('.shopify-section') || announcement || null;
      }

      measureChrome() {
        const announcementHeight = this.getElementHeight(this.announcementSection);
        const headerHeight = this.getElementHeight(this.stickyHeader || this.siteHeaderElement);
        return {
          announcementHeight,
          headerHeight,
          chromeHeight: announcementHeight + headerHeight
        };
      }

      getElementHeight(element) {
        if (!element) {
          return 0;
        }

        const style = window.getComputedStyle(element);
        const marginTop = parseFloat(style.marginTop) || 0;
        const marginBottom = parseFloat(style.marginBottom) || 0;
        return element.getBoundingClientRect().height + marginTop + marginBottom;
      }

      updatePositions() {
        if (!this.hideSiteHeader) {
          this.clearSiteHeaderState();
          return;
        }

        const { chromeHeight } = this.measureChrome();
        if (this.sectionWrapper) {
          this.sectionWrapper.style.top = `${Math.round(chromeHeight)}px`;
        }
      }

      setSiteChromeVisible(visible, active = true) {
        if (!this.hideSiteHeader) {
          this.clearSiteHeaderState();
          return;
        }

        const { announcementHeight, headerHeight, chromeHeight } = this.measureChrome();
        this.siteChromeVisible = visible;

        if (!active) {
          this.clearSiteHeaderState();
          if (this.sectionWrapper) {
            this.sectionWrapper.style.top = `${Math.round(chromeHeight)}px`;
          }
          return;
        }

        if (this.announcementSection) {
          this.announcementSection.style.position = 'fixed';
          this.announcementSection.style.top = '0px';
          this.announcementSection.style.right = '0px';
          this.announcementSection.style.left = '0px';
          this.announcementSection.style.zIndex = '42';
          this.announcementSection.style.width = '100%';
          this.announcementSection.style.transition = 'transform 0.3s ease';
          this.announcementSection.style.pointerEvents = visible ? '' : 'none';
          this.announcementSection.style.transform = visible ? 'translateY(0)' : `translateY(-${Math.round(announcementHeight)}px)`;
        }

        if (this.siteHeaderSection) {
          this.siteHeaderSection.classList.add('shopify-section-header-sticky', 'animate');
          this.siteHeaderSection.classList.remove('shopify-section-header-hidden');
        }

        if (this.siteHeaderElement) {
          this.siteHeaderElement.style.transition = 'transform 0.3s ease, top 0.3s ease';
          this.siteHeaderElement.style.pointerEvents = visible ? '' : 'none';
          this.siteHeaderElement.style.top = visible ? `${Math.round(announcementHeight)}px` : '0px';
          this.siteHeaderElement.style.transform = visible ? 'translateY(0)' : `translateY(-${Math.round(headerHeight)}px)`;
        }

        if (this.sectionWrapper) {
          this.sectionWrapper.style.top = visible ? `${Math.round(chromeHeight)}px` : '0px';
        }
      }

      getCurrentStickyTop() {
        if (!this.sectionWrapper) {
          return 0;
        }

        return Math.max(0, parseFloat(this.sectionWrapper.style.top) || 0);
      }

      getSectionDocumentTop() {
        let element = this.sectionWrapper || this;
        let top = 0;

        while (element) {
          top += element.offsetTop || 0;
          element = element.offsetParent;
        }

        return top;
      }

      updateActiveLink() {
        if (!this.links?.length) {
          return;
        }

        const offset = this.getBoundingClientRect().height + this.getCurrentStickyTop() + 24;
        let activeLink = this.links.find((link) => link.dataset.targetType === 'overview') || this.links[0];

        this.links.forEach((link) => {
          if (link.dataset.targetType !== 'anchor') {
            return;
          }

          const target = this.resolveTarget(link.dataset.targetId);
          if (!target) {
            return;
          }

          const rect = target.getBoundingClientRect();
          if (rect.top <= offset && rect.bottom > offset) {
            activeLink = link;
          }
        });

        this.links.forEach((link) => link.classList.toggle('is-active', link === activeLink));
      }
    }

    customElements.define('product-sticky-nav', ProductStickyNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jxs-pulse-bundle-included"] && !Shopify.designMode) return;
  try {
    
  if (!window.uahpetPulseProductCtaReady) {
    window.uahpetPulseProductCtaReady = true;
    document.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-pulse-product-cta]');
      if (!trigger) return;
      var target = document.querySelector('product-info[id^="MainProduct-"]');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jxs-pulse-early-bird-offer"] && !Shopify.designMode) return;
  try {
    
  if (!window.uahpetPulseProductCtaReady) {
    window.uahpetPulseProductCtaReady = true;
    document.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-pulse-product-cta]');
      if (!trigger) return;
      var target = document.querySelector('product-info[id^="MainProduct-"]');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uahpet-seo-guide"] && !Shopify.designMode) return;
  try {
    
function buildSeoGuideToc(root) {
  const content = root.querySelector('[data-seo-article-content]');
  const lists = root.querySelectorAll('[data-seo-toc-list]');
  if (!content || !lists.length) return;
  const headings = [...content.querySelectorAll('h2, h3')];
  if (!headings.length) {
    root.querySelectorAll('.seo-guide__toc').forEach((toc) => toc.hidden = true);
    return;
  }
  const used = new Set();
  headings.forEach((heading, index) => {
    let id = heading.id || heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    if (!id) id = `section-${index + 1}`;
    let uniqueId = id;
    let suffix = 2;
    while (used.has(uniqueId)) uniqueId = `${id}-${suffix++}`;
    used.add(uniqueId);
    heading.id = uniqueId;
  });
  lists.forEach((list) => {
    list.replaceChildren(...headings.map((heading) => {
      const item = document.createElement('li');
      item.dataset.level = heading.tagName.slice(1);
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.append(link);
      return item;
    }));
  });
}
document.querySelectorAll('.seo-guide').forEach(buildSeoGuideToc);
document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('.seo-guide');
  if (root) buildSeoGuideToc(root);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weekend-sale-anchor-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('weekend-anchor-nav')) {
    customElements.define('weekend-anchor-nav', class extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('[data-anchor-action]')]
        this.sectionLinks = this.links.filter((link) => link.dataset.anchorAction === 'section')
        this.targets = this.sectionLinks.map((link) => document.querySelector(`[data-weekend-anchor="${CSS.escape(link.dataset.anchorTarget)}"]`))
        this.viewport = this.querySelector('.weekend-anchor-nav__viewport')
        this.wrapper = this.closest('.shopify-section')
        this.behavior = this.dataset.scrollBehavior || 'smooth'
        this.frame = null

        this.handleClick = this.handleClick.bind(this)
        this.handleViewportChange = this.handleViewportChange.bind(this)
        this.links.forEach((link) => link.addEventListener('click', this.handleClick))
        window.addEventListener('scroll', this.handleViewportChange, { passive: true })
        window.addEventListener('resize', this.handleViewportChange, { passive: true })
        this.handleViewportChange()
      }

      disconnectedCallback() {
        this.links?.forEach((link) => link.removeEventListener('click', this.handleClick))
        window.removeEventListener('scroll', this.handleViewportChange)
        window.removeEventListener('resize', this.handleViewportChange)
        if (this.frame) cancelAnimationFrame(this.frame)
      }

      getHeaderOffset() {
        const header = document.querySelector('.section-header header')
        if (!header) return 0
        const rect = header.getBoundingClientRect()
        return Math.max(0, Math.min(rect.bottom, rect.height))
      }

      handleViewportChange() {
        if (this.frame) return
        this.frame = requestAnimationFrame(() => {
          this.frame = null
          const headerOffset = this.getHeaderOffset()
          if (this.wrapper) this.wrapper.style.top = `${headerOffset}px`
          this.updateActive(headerOffset)
        })
      }

      handleClick(event) {
        const link = event.currentTarget
        event.preventDefault()
        if (link.dataset.anchorAction === 'top') {
          window.scrollTo({ top: 0, behavior: this.behavior })
          return
        }

        const target = document.querySelector(`[data-weekend-anchor="${CSS.escape(link.dataset.anchorTarget)}"]`)
        if (!target) return
        const offset = this.getHeaderOffset() + this.offsetHeight
        const top = target.getBoundingClientRect().top + window.scrollY - offset
        window.scrollTo({ top, behavior: this.behavior })
        this.setActive(link)
      }

      updateActive(headerOffset) {
        const threshold = headerOffset + this.offsetHeight + 24
        let activeIndex = 0
        this.targets.forEach((target, index) => {
          if (target && target.getBoundingClientRect().top <= threshold) activeIndex = index
        })
        const activeLink = this.sectionLinks[activeIndex]
        if (activeLink) this.setActive(activeLink)
      }

      setActive(activeLink) {
        if (activeLink.classList.contains('is-active')) return
        this.links.forEach((link) => {
          const isActive = link === activeLink
          link.classList.toggle('is-active', isActive)
          if (isActive) link.setAttribute('aria-current', 'location')
          else link.removeAttribute('aria-current')
        })

        if (this.viewport && window.matchMedia('(max-width: 749px)').matches) {
          const left = activeLink.offsetLeft - (this.viewport.clientWidth - activeLink.offsetWidth) / 2
          this.viewport.scrollTo({ left: Math.max(0, left), behavior: this.behavior })
        }
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weekend-sale-featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('weekend-featured-product')) {
    class WeekendFeaturedProduct extends HTMLElement {}
    customElements.define('weekend-featured-product', WeekendFeaturedProduct)
  }

  document.querySelectorAll('.weekend-featured-product').forEach((section) => {
    if (section.dataset.initialized === 'true') return
    section.dataset.initialized = 'true'
    const dataNode = section.querySelector('[data-pack-data]')
    if (!dataNode) return
    const packs = JSON.parse(dataNode.textContent)
    let activeIndex = 0
    let switchToken = 0
    const packButtons = [...section.querySelectorAll('[data-pack-index]')]
    const sceneLink = section.querySelector('[data-scene-link]')
    const scenePicture = section.querySelector('[data-scene-picture]')
    const productLink = section.querySelector('[data-product-link]')
    const productImage = section.querySelector('[data-product-image]')
    const price = section.querySelector('[data-price]')
    const comparePrice = section.querySelector('[data-compare-price]')
    const saveBadge = section.querySelector('[data-save-badge]')
    const variantInput = section.querySelector('[data-variant-id]')
    const submit = section.querySelector('[data-submit]')
    const submitLabel = section.querySelector('[data-submit-label]')
    const productForm = section.querySelector('.weekend-featured-product__form')
    const packSelect = section.querySelector('[data-pack-select]')
    const previousArrow = section.querySelector('[data-direction="previous"]')
    const nextArrow = section.querySelector('[data-direction="next"]')
    let submitResetTimer

    const setSubmitState = (state, label, resetDelay) => {
      if (!submit || !submitLabel) return
      window.clearTimeout(submitResetTimer)
      submit.classList.remove('is-success', 'is-error')
      if (state === 'success') submit.classList.add('is-success')
      if (state === 'error') submit.classList.add('is-error')
      submitLabel.textContent = label
      if (resetDelay) {
        submitResetTimer = window.setTimeout(() => {
          const pack = packs[activeIndex]
          submit.classList.remove('is-success', 'is-error')
          submitLabel.textContent = pack.available ? (submit.dataset.buttonLabel || 'Add To Cart') : (submit.dataset.soldOutLabel || 'Sold Out')
        }, resetDelay)
      }
    }

    const updateArrowState = () => {
      if (previousArrow) {
        previousArrow.disabled = activeIndex === 0
        previousArrow.setAttribute('aria-disabled', String(previousArrow.disabled))
      }
      if (nextArrow) {
        nextArrow.disabled = activeIndex === packs.length - 1
        nextArrow.setAttribute('aria-disabled', String(nextArrow.disabled))
      }
    }

    const preload = (url) => {
      if (!url) return
      const image = new Image()
      image.src = url
    }

    const applyPack = (nextIndex) => {
      const pack = packs[nextIndex]
      if (!pack || nextIndex === activeIndex) return
      const token = ++switchToken
      section.classList.add('is-switching')
      window.setTimeout(() => {
        if (token !== switchToken) return
        activeIndex = nextIndex
        packButtons.forEach((button, index) => {
          const isActive = index === activeIndex
          button.classList.toggle('is-active', isActive)
          button.setAttribute('aria-pressed', String(isActive))
        })
        if (packSelect) packSelect.value = String(activeIndex)
        if (sceneLink) sceneLink.href = pack.url
        if (productLink) productLink.href = pack.url
        if (scenePicture && pack.sceneDesktop) {
          const image = scenePicture.querySelector('img')
          const source = scenePicture.querySelector('source')
          image.removeAttribute('srcset')
          image.removeAttribute('sizes')
          image.src = pack.sceneDesktop
          image.alt = pack.sceneAlt || ''
          if (source) source.srcset = pack.sceneMobile || pack.sceneDesktop
        }
        if (productImage && pack.productImage) {
          productImage.removeAttribute('srcset')
          productImage.removeAttribute('sizes')
          productImage.src = pack.productImage
          productImage.alt = pack.productAlt || ''
        }
        price.textContent = pack.price
        comparePrice.hidden = !pack.comparePrice
        comparePrice.textContent = pack.comparePrice || ''
        if (saveBadge) {
          saveBadge.hidden = !pack.save
          if (pack.save) saveBadge.textContent = `${section.dataset.savePrefix || 'SAVE'} ${pack.save}`
        }
        variantInput.value = pack.id
        window.clearTimeout(submitResetTimer)
        submit.classList.remove('is-success', 'is-error')
        submit.disabled = !pack.available
        submit.setAttribute('aria-disabled', String(!pack.available))
        submitLabel.textContent = pack.available ? (submit.dataset.buttonLabel || 'Add To Cart') : (submit.dataset.soldOutLabel || 'Sold Out')
        updateArrowState()
        section.classList.remove('is-switching')
      }, 190)
    }

    packButtons.forEach((button) => button.addEventListener('click', () => applyPack(Number(button.dataset.packIndex))))
    if (packSelect) packSelect.addEventListener('change', () => applyPack(Number(packSelect.value)))
    section.querySelectorAll('[data-direction]').forEach((button) => button.addEventListener('click', () => {
      const offset = button.dataset.direction === 'next' ? 1 : -1
      const nextIndex = activeIndex + offset
      if (nextIndex < 0 || nextIndex >= packs.length) return
      applyPack(nextIndex)
    }))

    if (productForm) {
      productForm.addEventListener('submit', () => {
        setSubmitState('loading', submit.dataset.addingLabel || 'Adding...')
      })
    }

    document.addEventListener('afterCartChanged', (event) => {
      if (String(event.detail?.productVariantId) !== String(variantInput.value)) return
      setSubmitState('success', submit.dataset.addedLabel || 'Added ✓', 1600)
    })

    document.addEventListener('afterAddCartError', (event) => {
      if (String(event.detail?.productVariantId) !== String(variantInput.value)) return
      setSubmitState('error', submit.dataset.errorLabel || 'Try Again', 2400)
    })

    updateArrowState()

    if (packs[1]) {
      const mediaQuery = window.matchMedia('(max-width: 749px)')
      preload(mediaQuery.matches ? packs[1].sceneMobile : packs[1].sceneDesktop)
      preload(packs[1].productImage)
    }
  })

  } catch(e) { console.error(e); }
})();
})();
